import { createFileRoute } from '@tanstack/react-router';

function RouteComponent() {
  return <div>Hello "/_auth/sair"!</div>;
}

export const Route = createFileRoute('/_auth/sair')({
  component: RouteComponent,
});
